import PropTypes from 'prop-types';
import React from 'react';
function Error(_ref) {
  var {
    error
  } = _ref;
  if (!error) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "field-error pt-25 flex"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 20 20",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zM9 9a1 1 0 0 0 2 0V7a1 1 0 1 0-2 0v2zm0 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"
  })), /*#__PURE__*/React.createElement("span", {
    className: "pl-25 text-critical"
  }, error));
}
Error.propTypes = {
  error: PropTypes.string
};
Error.defaultProps = {
  error: undefined
};
export default Error;